import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const CREATE_USER = gql`
  mutation CreateUser($data: CreateUserInput!) {
    createUser(data: $data) {
      message
    }
  }
`;

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_USER = gql`
  mutation UpdateUser($where: UserUniqueInput!, $data: UserUpdateInput!) {
    updateUser(where: $where, data: $data) {
      message
    }
  }
`;

export const UPDATE_RIDER_SKIP_INSPECTION = gql`
  mutation UpdateUser($where: UserUniqueInput!, $data: UserUpdateInput!) {
    updateUser(where: $where, data: $data) {
      data {
        id
        firstName
        skipPickupInspection
      }
      message
    }
  }
`;

// eslint-disable-next-line import/prefer-default-export
export const REQUEST_USER_EXPORT = gql`
  mutation RequestUserExport(
    $data: RequestExportInput!
    $filter: RequestUserExportFilterInput
  ) {
    requestUserExport(data: $data, filter: $filter) {
      message
    }
  }
`;

// eslint-disable-next-line import/prefer-default-export
export const BULK_UPDATE_USER_TAGS = gql`
  mutation BulkUpdateUserTags($data: BulkUpdateUserTagsInput!) {
    bulkUpdateUserTags(data: $data) {
      message
    }
  }
`;

export const REVEAL_USER_PII = gql`
  mutation RevealUserPii($data: RevealUserPiiInput!) {
    revealUserPii(data: $data) {
      data {
        email
        contactNo
      }
    }
  }
`;
